import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';
import { Requerimientos3Service } from "app/main/pagina/tools/requerimientos3/requerimientos3.service";
import { EditorEncuestaService } from "app/main/pagina/productos/certificar/tipo_2/editor-encuesta/editor-encuesta.service";

@Component({
  selector: 'app-info-rt',
  templateUrl: './info-rt.component.html',
  styleUrls: ['./info-rt.component.scss'],
  animations   : fuseAnimations
})
export class InfoRTComponent implements OnInit {

  idiomaNative: string;
  pasos = [
    {clave: 'autentication', cargando: true, completo: false, delay: '250ms'},
    {clave: 'testAccess', cargando: true, completo: false, delay: '350ms'},
    {clave: 'testEmail', cargando: true, completo: false, delay: '450ms'},
    {clave: 'validationQ', cargando: true, completo: false, delay: '550ms'},
    {clave: 'requirements', cargando: true, completo: false, delay: '650ms'},
  ];
  cuestionario: any;
  verHistorial = false;
  sinIdiomas = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public datos: any,
    public dialogRef: MatDialogRef<InfoRTComponent>,
    private reqService: Requerimientos3Service,
    private edEncSrv: EditorEncuestaService,
  ) { }

  ngOnInit() {
    this.obtieneIdiomasGuardados();
  }

  obtieneIdiomasGuardados(){
    this.edEncSrv.getIdiomasProd(this.datos.empresaId,this.datos.productoId).subscribe( (respuesta: any) => {
      console.log("getIdiomas:",respuesta);
      if(respuesta.idiomasMostrar.length > 0){
        let indiceIdiomaNativo = respuesta.idiomasMostrar.findIndex(item => item.tipoIdioma == "1");
        this.idiomaNative = respuesta.idiomasMostrar[indiceIdiomaNativo].nombreIdioma;
        this.getBanderasRequerimientos();
        this.getCuestionarioRequerimientosTecnico();
      }
      else this.sinIdiomas = true;
    });
  }

  getBanderasRequerimientos(){
    this.reqService.getBanderasRequerimientosTecnicos(this.datos.empresaId,this.datos.productoId).subscribe((respuesta:any) => {
      console.log("getBanderas:",respuesta);
      let banderasRT = respuesta.requerimientosv3;
      this.pasos.forEach(paso => {
        paso.completo = banderasRT[paso.clave];
        paso.cargando = false;
      });
    });
  }

  getCuestionarioRequerimientosTecnico(){
    this.reqService.getCatalogoPreguntasRequerimientos(this.datos.productoId,this.idiomaNative).subscribe((respuesta:any) => {
      console.log("getCuestionario:",respuesta);
      this.cuestionario = respuesta.data;
    });
  }

  cerrar(): void {
    this.dialogRef.close();
  }
}
